export default {
	jobs: {
		data: [],
		meta: {
			total: 0,
			per_page: 5,
			current_page: 1,
		},
	},
	listener: null,
};
